module.exports = __webpack_public_path__ + "static/media/aMANA-logo.b091957f.png";